// extracted by mini-css-extract-plugin
export default {"label":"SimpleLabel-module__label___A_4Hq"};